// src/pages/Community/Vehicles/normalizeVehicle.js

export function normalizeVehicle(d = {}) {
    const clean = (v) => (typeof v === "string" ? v.trim() : v);

    return {
        id: d.id,
        name: d.name ?? "Unnamed Vehicle",
        slug: d.slug ?? null,
        type: d.type ?? "Vehicle",

        make: d.manufacturer ?? null,
        class: d.class ?? null,
        classOriginal: d.classOriginal ?? null,

        price: typeof d.price === "number" ? d.price : null,
        seats: d.seats ?? null,
        drivetrain: d.drivetrain ?? null,

        waterCapable: !!d.waterCapable,
        boostNitro: !!d.boostNitro,

        topSpeedKph: d.topSpeedKph ?? null,
        accel0to100: d.accel0to100 ?? null,
        brake100to0m: d.brake100to0m ?? null,
        handling: d.handling ?? null,
        armor: d.armor ?? null,

        performance: d.performanceStats ?? {},

        description: clean(d.description),
        acquisition: clean(d.acquisition),
        designInspiration: clean(d.designInspiration),
        storage: clean(d.storage),

        spawnLocations: Array.isArray(d.spawnLocations) ? d.spawnLocations : [],
        tags: Array.isArray(d.tags) ? d.tags : [],

        gallery: Array.isArray(d.gallery) ? d.gallery : [],
        portrait: d.coverUrl || d.coverImage || d.gallery?.[0] || null,
        videoUrl: d.videoUrl ?? null,

        authorName: d.authorName ?? "Unknown",
        authorUid: d.authorUid ?? null,

        createdAt: d.createdAt,
        updatedAt: d.updatedAt,
    };
}
